export const CLEAR_SUPPORT_REQ = "CLEAR_SUPPORT_REQ"
export const SUPPORT_REQUEST = "SUPPORT_REQUEST"
export const SUPPORT_SUCCESS = "SUPPORT_SUCCESS"